import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json"
import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { SelectBox } from "devextreme-react/select-box";
import Form from 'devextreme-react/form';
import { alert } from "devextreme/ui/dialog";
import AccordionReact from 'devextreme-react/accordion';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { downloadReportFile } from "../../../common/Utils";

let accessToken = "";
const blockSelectBox = React.createRef();

const panel = [
  {
    ID: 1,
    Title: 'Print Asset Tags'
  }
];

class AssetTags extends React.Component {
  constructor(props) {
    super(props);

    accessToken = props.oidc.user.access_token;

    this.state = {
      loadIndicatorVisible: false,
      loadPanelVisible: false,
      block: "",
      selectedItems: [panel[0]],
      filter: {
        BeginingRow: 0,
        EndingRow: 0,
        BeginingColumn: 0,
        EndingColumn: 0,
        AllAssignedPositions: false,
        OccupiedPositions: true,
        CenterFoldVersionForWirePin: true,
        SingleVersionForHarvestTag: false
      }
    };

    this.previewButtonClicked = this.previewButtonClicked.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);
    this.blockChanged = this.blockChanged.bind(this);
    this.formFieldChanged = this.formFieldChanged.bind(this);
    this.selectionChanged = this.selectionChanged.bind(this);
    this.hideLoadPanel = this.hideLoadPanel.bind(this);

    this.blockDataSource = createStore({
      key: "id",
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Blocks.GetBlockDescriptions}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

  }

  hideLoadPanel() {
    this.setState({ loadPanelVisible: false });
  }

  selectionChanged(e) {
    let newItems = [...this.state.selectedItems];
    e.removedItems.forEach((item) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    this.setState({ selectedItems: newItems });
  }

  render() {
    const position = { of: '#accordion-container-asset-tags' };
    return (
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <style>
          {`
            #accordion-asset-tags {
              --accordion-body-max-height: calc(100vh - 150px) !important;
            }
            #accordion-asset-tags .dx-accordion-item-body {
              max-height: calc(100vh - 150px) !important;
              height: auto !important;
            }
            #accordion-container-asset-tags {
              --accordion-body-max-height: calc(100vh - 150px) !important;
            }
            #accordion-container-asset-tags .dx-accordion-item-body {
              max-height: calc(100vh - 150px) !important;
              height: auto !important;
            }
          `}
        </style>
        <div className="row" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden', marginLeft: "2px" }}>
          <div className="col-md-12" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden', paddingLeft: "0px", paddingRight: "0px" }}>
            <div id="accordion-asset-tags" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={this.hideLoadPanel}
                visible={this.state.loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
              />
              <AccordionReact
                dataSource={panel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={this.state.selectedItems}
                onSelectionChanged={e => {
                  if (e.currentTarget === e.target) {
                    this.selectionChanged(e, e.target);
                  }
                }}
                itemTitleRender={() => (
                  <Toolbar className="accordian-toolbarss">
                    <Item location="before">
                      <div className="title">
                        <h6
                          style={{
                            color: window._env_.Color2
                          }}
                        >
                          Print Asset Tags
                        </h6>
                      </div>
                    </Item>
                    <Item location="after">
                      <Button
                        className="accordianButton"
                        text="Reset"
                        onClick={this.resetButtonClicked}
                      />
                    </Item>
                    <Item location="after">
                      <Button
                        className="accordianButton"
                        type="default"
                        onClick={this.previewButtonClicked}
                      >
                        <LoadIndicator
                          style={{
                            height: "20px",
                            width: "20px",
                            verticalAlign: "middle",
                            marginRight: "5px",
                          }}
                          visible={this.state.loadIndicatorVisible}
                        />
                        <span className="dx-button-text">Preview</span>
                      </Button>
                    </Item>
                  </Toolbar>
                )}
                itemRender={(itemProps) => (
                  <div style={{ padding: '10px', height: '100%', overflowY: 'auto' }}>
                    <div className="row">
                      <div className="col-md-12">
                        <SelectBox
                          ref={blockSelectBox}
                          placeholder="Block Name"
                          dataSource={this.blockDataSource}
                          displayExpr="name"
                          valueExpr="id"
                          onValueChanged={this.blockChanged}
                          searchEnabled={true}
                          showClearButton={true}
                          width="100%"
                          labelMode="static"
                          label="Block Name"
                        />
                      </div>
                    </div>
                    <div className="row" style={{ paddingTop: '10px' }}>
                      <div className="col-md-12">
                        <Form
                          id="form"
                          labelMode="static"
                          labelLocation="left"
                          formData={this.state.filter}
                          minColWidth={200}
                          colCount={2}
                          onFieldDataChanged={this.formFieldChanged}
                        />
                      </div>
                    </div>
                  </div>
                )}
                id="accordion-container-asset-tags"
                style={{ flex: '1 1 auto', minHeight: 0, height: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  blockChanged(e) {
    this.setState({
      block: e.value,
    });

  }

  resetButtonClicked(e) {
    if (e && e.event) {
      e.event.stopPropagation();
    }
    this.setState({
      loadPanelVisible: true,
      block: "",
      filter: {
        BeginingRow: 0,
        EndingRow: 0,
        BeginingColumn: 0,
        EndingColumn: 0,
        AllAssignedPositions: false,
        OccupiedPositions: true,
        CenterFoldVersionForWirePin: true,
        SingleVersionForHarvestTag: false
      }
    });

    if (blockSelectBox.current && blockSelectBox.current.instance) {
      blockSelectBox.current.instance().reset();
    }
    setTimeout(this.hideLoadPanel, 1000);
  }

  previewButtonClicked(e) {
    if (e && e.event) {
      e.event.stopPropagation();
    }
    if (this.state.block == "") {
      notify(
        {
          message: "Select a block before printing tags",
          width: 100,
        },
        'error',
        3000,
      );
      return;
    }

    this.setState({
      loadIndicatorVisible: true,
      loadPanelVisible: true
    });

    var request = new Object();
    request.Block = this.state.block;
    request.BeginingRow = this.state.filter.BeginingRow;
    request.EndingRow = this.state.filter.EndingRow;
    request.BeginingColumn = this.state.filter.BeginingColumn;
    request.EndingColumn = this.state.filter.EndingColumn;
    request.AllAssignedPositions = this.state.filter.AllAssignedPositions;
    request.OccupiedPositions = this.state.filter.OccupiedPositions;
    request.CenterFoldVersionForWirePin = this.state.filter.CenterFoldVersionForWirePin;
    request.SingleVersionForHarvestTag = this.state.filter.SingleVersionForHarvestTag;

    axios.post
      (
        `${window._env_.REACT_APP_APIS}/${routes.AssetTag.GenerateAssetTags}`, request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        if (res.data.isSuccess) {
          notify(
            {
              message: "Asset tags generated successfully",
              width: 100,
            },
            'success',
            3000,
          );
          // Returned so the loader stays up until the file has downloaded.
          return downloadReportFile(res.data.fileName, accessToken);
        } else {
          notify(
            {
              message: res.data.message || "Failed to generate asset tags",
              width: 100,
            },
            'error',
            3000,
          );
        }

      })
      .catch((err) => {
        notify(
          {
            message: err.message || "An error occurred",
            width: 100,
          },
          'error',
          3000,
        );
      })
      .finally(() => {
        this.setState({
          loadIndicatorVisible: false,
          loadPanelVisible: false,
        });
      });
  }

  formFieldChanged(e) {

    if (e.dataField === "AllAssignedPositions") {
      if (this.state.filter.AllAssignedPositions) {
        var filter = { ...this.state.filter };
        filter.OccupiedPositions = false;
        this.setState({ filter });
      }
    }

    if (e.dataField === "OccupiedPositions") {
      if (this.state.filter.OccupiedPositions) {
        var filter = { ...this.state.filter };
        filter.AllAssignedPositions = false;
        this.setState({ filter });
      }
    }

    if (e.dataField === "CenterFoldVersionForWirePin") {
      if (this.state.filter.CenterFoldVersionForWirePin) {
        var filter = { ...this.state.filter };
        filter.SingleVersionForHarvestTag = false;
        this.setState({ filter });
      }
    }

    if (e.dataField === "SingleVersionForHarvestTag") {
      if (this.state.filter.SingleVersionForHarvestTag) {
        var filter = { ...this.state.filter };
        filter.CenterFoldVersionForWirePin = false;
        this.setState({ filter });
      }
    }

  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(AssetTags);
